<div class="browser-center">
  <mat-spinner diameter="300"></mat-spinner>
</div>
